import { definePresentationResponse } from "../presenter"

export interface Toast {
  readonly message: string
  readonly title?: string
  readonly severity?: "info" | "success" | "warning" | "error"
  readonly durationMs?: number
  readonly action?: { readonly id: string; readonly label: string }
}

export type ToastResult =
  | { readonly reason: "action"; readonly actionId: string }
  | { readonly reason: "dismissed" }
  | { readonly reason: "expired" }

export const Toast = definePresentationResponse<Toast, ToastResult>({
  type: "Toast",
  namespace: "Florisoft.Framework.Presentation",
})
